import { render, staticRenderFns } from "./CouponDropdown.vue?vue&type=template&id=2f4f88f9&scoped=true&"
import script from "./CouponDropdown.vue?vue&type=script&lang=js&"
export * from "./CouponDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CouponDropdown.vue?vue&type=style&index=0&id=2f4f88f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4f88f9",
  null
  
)

export default component.exports